import React, { useEffect, useState } from "react";
import styles from "./SpeakersSettings.module.scss";
import axios from "axios";
import Button from "../../UiComponents/Button";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";
import SpeakersGraph from "./SpeakersGraph";
import {
  displayAngleValue,
  displayCalibValue,
  ticksToDate,
} from "../../calibration/functionDataSorted";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import speakers from "../../../pics/speakersPdf.png";
import neuronalSpeakers from "../../../pics/neuronal_speakers.png";
import Axios from "../../../_services/caller.service";
//IMPORT EXPORT
import download from "downloadjs";
import ModalConfirmRegisterNewValue from "../calibrationData/Modal/ModalConfirmRegisterNewValue";
import DropZone from "../../UiComponents/dropZone/DropZone";
import { useTranslation } from "react-i18next";
import ModalNotGoodOupout from "../calibrationData/Modal/ModalNotGoodOupout";
import ModalComfirmImport from "../calibrationData/Modal/ModalComfirmImport";
import { convertDateToTicks } from "../../../utils/handleDateTicks";
import { emptyDataAngle } from "./emptyDataAngle";
import { toast } from "react-toastify";
import LoaderLogin from "../../UiComponents/loader/LoaderLogin";
import { decodedB64 } from "../../../CustomHooks/DecodedBase64";
import { PermissionGate } from "../managePermissions/PermissionGate";

const SpeakersSettings = ({ cabine, cabId, setCabId, cabname, onCalibrationSaved }) => {
  const { t } = useTranslation();
  //ANGLE DATA
  const [infosAngle, setInfosAngle] = useState([]);

  //VALUE DATA
  const [speakersGeneral, setSpeakersGeneral] = useState({});
  const [speakersVocal, setSpeakersVocal] = useState({});
  const [speakersTonal, setSpeakersTonal] = useState({});
  //DISPLAY
  const [displaySpeakers, setDisplaySpeakers] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSucess] = useState(false);
  const [dateCalibration, setDateCalibration] = useState("");
  const [maj, setMaj] = useState(false);
  //SERIAL AND NAME MICS
  const [microphoneName, setMicrophoneName] = useState("");
  const [microphoneSerial, setMicrophoneSerial] = useState("");
  //IMPORT EXPORT FILE TXT
  const [selectedFile, setSelectedFile] = useState();
  const [modalConfirmImport, setModalConfirmImport] = useState(false);
  const [modalConfirmRegisterNewValue, setModalConfirmRegisterNewValue] =
    useState(false);
  const [modalNotGoodOutpout, setModalNotGoodOutpout] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [isCheckedDateUpdate, setIsCheckedDateUpdate] = useState(false);
  //LOADING
  const [loadinginfosAngleSettings, setLoadinginfosAngleSettings] =
    useState(true);
  const [loadingVoc, setloadingVoc] = useState(true);
  const [loadingTon, setloadingTon] = useState(true);
  const [loadingGen, setloadingGen] = useState(true);
  const [loadingCalibrationTonalForDate, setLoadingCalibrationTonalForDate] =
    useState(true);

  const [loadingAllData, setLoadingAllData] = useState(true);

  //WARNING
  const [warningMessage, setWarningMessage] = useState("");

  //GET ANGLE INFOS
  useEffect(() => {
    if (cabId !== "") {
      const controller = new AbortController();
      Axios.get(`/infosAngleSettings/${cabId}`, { signal: controller.signal })
        .then(async (response) => {
          setLoadinginfosAngleSettings(false);
          if (response.data.data.length === 0) {
            setInfosAngle(emptyDataAngle);
          } else {
            setInfosAngle(response.data.data);
          }
        })
        .catch(function (error) {
          if (error.name !== "CanceledError") console.log(error);
        });

      return () => controller.abort();
    }
  }, [cabId, setCabId, maj]);

  //GET CALIBRATION INFOS

  useEffect(() => {
    const speakerNames = [
      "G",
      "D",
      "C",
      "SRG",
      "SRD",
      "BG",
      "BD",
    ]; // You can extend this array

    const controller = new AbortController();
    const fetchDataTonal = async () => {
      let dateTonal = "";
      try {
        const response = await Axios.get(`/calibrationTonal/${cabId}`, { signal: controller.signal });

        if (response.data.message === "aucune donnée") {
          let speakerObj = {};
          speakerNames.forEach((name) => {
            speakerObj[name] = Array(11).fill("0");
          });
          setSpeakersTonal(speakerObj);
        } else {
          const allValueSpeakers = response.data.data;
          const valueT = displayCalibValue(allValueSpeakers, "Speakers_Value");
          dateTonal = displayCalibValue(allValueSpeakers, "Speakers_Passed");
          dateTonal = dateTonal[0];
          const values = valueT[0].split(",");
          let speakerObj = {};
          for (let i = 0; i < values.length; i += 11) {
            const speakerIndex = i / 11;
            if (speakerNames[speakerIndex]) {
              speakerObj[speakerNames[speakerIndex]] = values.slice(i, i + 11);
            }
          }

          setSpeakersTonal(speakerObj);

          const micsName = displayCalibValue(
            allValueSpeakers,
            "Speakers_MicrophoneName"
          )[0];
          setMicrophoneName(decodedB64(micsName));
          const micsSerial = displayCalibValue(
            allValueSpeakers,
            "Speakers_MicrophoneSerial"
          )[0];
          setMicrophoneSerial(micsSerial);
        }
      } catch (error) {
      } finally {
        setloadingTon(false);
      }

      return dateTonal;
    };
    const fetchDataVocal = async () => {
      let dateVocal = "";
      try {
        const response = await Axios.get(`/calibrationVocal/${cabId}`, { signal: controller.signal });

        if (response.data.message === "aucune donnée") {
          let speakerObj = {};
          speakerNames.forEach((name) => {
            speakerObj[name] = Array(1).fill("0");
          });
          setSpeakersVocal(speakerObj);
        } else {
          const allValueSpeakers = response.data.data;
          const valueT = displayCalibValue(allValueSpeakers, "Speakers_Value");
          dateVocal = displayCalibValue(allValueSpeakers, "Speakers_Passed");
          dateVocal = dateVocal[0];
          const values = valueT[0].split(",");
          let speakerObj = {};
          for (let i = 0; i < values.length; i += 1) {
            const speakerIndex = i / 1;
            if (speakerNames[speakerIndex]) {
              speakerObj[speakerNames[speakerIndex]] = values.slice(i, i + 1);
            }
          }

          setSpeakersVocal(speakerObj);
        }
      } catch (error) {
      } finally {
        setloadingVoc(false);
      }

      return dateVocal;
    };
    const fetchDataGeneral = async () => {
      let dateGeneral = "";
      try {
        const response = await Axios.get(`/calibrationGeneral/${cabId}`, { signal: controller.signal });

        if (response.data.message === "aucune donnée") {
          setSpeakersGeneral("0");
        } else {
          const allValueSpeakers = response.data.data;
          const valueT = displayCalibValue(allValueSpeakers, "Speakers_Value");
          dateGeneral = displayCalibValue(allValueSpeakers, "Speakers_Passed");
          dateGeneral = dateGeneral[0];
          const values = valueT[0];

          setSpeakersGeneral(values);
        }
      } catch (error) {
      } finally {
        setloadingGen(false);
      }

      return dateGeneral;
    };

    if (cabId !== "") {
      Promise.all([
        fetchDataVocal(),
        fetchDataTonal(),
        fetchDataGeneral(),
      ]).then(([dateVocal, dateTonal, dateGeneral]) => {
        const allDatesExist = dateGeneral && dateTonal && dateVocal;

        if (allDatesExist) {
          setDateCalibration(dateTonal); // Utiliser dateGeneral comme exemple

          setWarningMessage(""); // Pas de message d'avertissement nécessaire
          setLoadingCalibrationTonalForDate(false);
        } else {
          setDateCalibration("");

          setLoadingCalibrationTonalForDate(false);
          let speakerObj = {};
          speakerNames.forEach((name) => {
            speakerObj[name] = Array(11).fill("0");
          });
          setSpeakersTonal(speakerObj);
          let speakerObjVocal = {};
          speakerNames.forEach((name) => {
            speakerObjVocal[name] = Array(1).fill("0");
          });
          setSpeakersVocal(speakerObjVocal);
          setSpeakersGeneral("0");
        }
      });

      return () => controller.abort();
    }
  }, [cabId, setCabId, maj, setMaj]);

  const handleInputChangeTonal = (event, key, index) => {
    const value = event.target.value;

    setSpeakersTonal((prevSpeakers) => ({
      ...prevSpeakers,
      [key]: prevSpeakers[key].map((item, i) => (i === index ? value : item)),
    }));
  };

  const handleInputChangeVocal = (event, key, index) => {
    const value = event.target.value;

    setSpeakersVocal((prevSpeakers) => ({
      ...prevSpeakers,
      [key]: prevSpeakers[key].map((item, i) => (i === index ? value : item)),
    }));
  };

  //REGISTER NEW VALUE SPEAKERS

  const registerNewValueSpeakers = async (params) => {
    try {
      setLoading(true);

      const date =
        isCheckedDateUpdate || !dateCalibration
          ? convertDateToTicks()
          : dateCalibration; // date now or date old

      // Create catid if they don't exist in DB
      const responseCreateCatid = await Axios.post(`/createCatid/${cabId}`);
      await Axios.post(`/createCatidSpeakersSetup/${cabId}`);

      //  Register calib data
      await Axios.put(`/newValueSpeakersGeneral/${cabId}`, {
        data: { calibGeneral: speakersGeneral, date: date },
      });
      await Axios.put(`/newValueSpeakersTonal/${cabId}`, {
        calibTonal: speakersTonal,
        date: date,
      });
      await Axios.put(`/newValueSpeakersVocal/${cabId}`, {
        calibVocal: speakersVocal,
        date: date,
      });
      await Axios.put(`/newValueSpeakersAngle/${cabId}`, {
        data: infosAngle,
      });

      setOverlay(false); // dans le cas d'import
      setModalConfirmImport(false); // dans le cas d'import
      setModalConfirmRegisterNewValue(false); // dans le cas de nouvelle valeur
      setMaj(!maj);
      setLoading(false);

      toast.success(t("calibration_data.data_saved_success"));
      if (onCalibrationSaved) onCalibrationSaved();

      toast.success(responseCreateCatid.data.message);
    } catch (error) {
      toast.error(t("calibration_data.error_occurred"), {
        autoClose: false,
      });
    }
  };

  //IMPORT AND EXPORT CALIBRATION DATA

  const checkHandler = () => {
    setIsCheckedDateUpdate(!isCheckedDateUpdate);
  };

  const exportCalibDataSpeakers = async () => {
    const calibDate = ticksToDate(dateCalibration);
    console.log(speakersVocal);
    // Create a TXT file
    const data = {
      Eoutpout: "Speakers",
      date: dateCalibration,
      general: speakersGeneral,
      vocal: speakersVocal,
      tonal: speakersTonal,
      angle: infosAngle,
    };

    const dataStr = JSON.stringify(data);
    const filename = `Speakers Calibration Data [${cabname}${cabId}] ${calibDate}.txt`;
    const filetype = "text/plain";

    // Download the file
    download(dataStr, filename, filetype);
  };

  const fileChangedHandler = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) {
      importCalibDataSpeakers();
    }
  }, [selectedFile]);

  const importCalibDataSpeakers = () => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      // The file's text will be printed here
      const text = e.target.result;

      const data = JSON.parse(text);

      if (data.Eoutpout !== "Speakers") {
        setModalNotGoodOutpout(true);
        setOverlay(true);
        return;
      }

      //VOIR ICI POUR METTRE LA DATA DANS LES STATES
      const angle = data.angle;
      const general = data.general;
      const vocal = data.vocal;
      const tonal = data.tonal;
      const date = data.date;

      setInfosAngle(angle);
      setSpeakersGeneral(general);
      setSpeakersVocal(vocal);
      setSpeakersTonal(tonal);
      setDateCalibration(date);
      setModalConfirmImport(true);
      setOverlay(true);
    };

    reader.readAsText(selectedFile);
  };

  const frequencies = [
    "125Hz",
    "250Hz",
    "500Hz",
    "750Hz",
    "1Khz",
    "1.5Khz",
    "2Khz",
    "3Khz",
    "4Khz",
    "6KHz",
    "8KHz",
  ];

  // Surveiller tous les états de chargement
  useEffect(() => {
    if (
      !loadinginfosAngleSettings &&
      !loadingGen &&
      !loadingTon &&
      !loadingVoc &&
      !loadingCalibrationTonalForDate
    ) {
      setLoadingAllData(false); // Tout est chargé
    }
  }, [
    loadinginfosAngleSettings,
    loadingGen,
    loadingTon,
    loadingVoc,
    loadingCalibrationTonalForDate,
  ]);

  const speakerLabelMap = {
    FRONT_LEFT: "G",
    FRONT_RIGHT: "D",
    FRONT_CENTER: "C",
    SURROUND_LEFT: "SRG",
    SURROUND_RIGHT: "SRD",
    BACK_LEFT: "BG",
    BACK_RIGHT: "BR",
  };

  return (
    <>
      {loadingAllData && <LoaderLogin />}

      <>
        <div className={styles.containerSpeakers}>
          {overlay && <div className={styles.overlay}></div>}
          <img
            className={styles.currentCalibrationImg}
            src={neuronalSpeakers}
            alt=""
          />
          <div className={styles.cabnameAndType}>
            <h2>Calibration CL ➡️ </h2>
            <h3>
              {cabname}({cabId})
            </h3>
          </div>

          <div className={styles.containerBtnExport}>
            <PermissionGate actionKey="cabines.transducers.calibration.export">
              <Button
                onPress={exportCalibDataSpeakers}
                styles={"btnExport"}
                text={t("calibration_data.export")}
              />
            </PermissionGate>
            <div className={styles.containerImport}>
              <div className={styles.containerInputImport}>
                {/* // <DropZone onFileUpload={fileChangedHandler} /> */}
                <label className={styles.uploadLabel}>
                  {t("calibration_data.select_file")}
                  <PermissionGate actionKey="cabines.transducers.calibration.import">
                    <input
                      type="file"
                      onChange={(e) => fileChangedHandler(e.target.files[0])}
                      className={styles.hiddenInput}
                    />
                  </PermissionGate>
                </label>

                {/* <Button
                  onPress={() => {
                    setMaj(!maj);
                  }}
                  styles={"btnPrimary"}
                  text={"Reset"}
                /> */}
              </div>
            </div>
          </div>

          {modalNotGoodOutpout && (
            <ModalNotGoodOupout
              setOverlay={setOverlay}
              setModalNotGoodOutpout={setModalNotGoodOutpout}
            />
          )}

          {modalConfirmImport && (
            <ModalComfirmImport
              setModalConfirmImport={setModalConfirmImport}
              setOverlay={setOverlay}
              isCheckedDateUpdate={isCheckedDateUpdate}
              checkHandler={checkHandler}
              setMaj={setMaj}
              maj={maj}
              setModalConfirmRegisterNewValue={setModalConfirmRegisterNewValue}
              registerNewValue={registerNewValueSpeakers}
            />
          )}
          <div className={styles.containerAllValueAngle}>
            {infosAngle.length >= 1 &&
              infosAngle.slice(1).map((angle, index) => {
                return (
                  <div key={index} className={styles.containerValueAngle}>
                    <span className={styles.rowLabel}>{speakerLabelMap[angle.fname] || angle.fname}</span>

                    <input
                      key={angle.fname}
                      onChange={(e) => {
                        const newInfosAngle = infosAngle.map((item) =>
                          item.fname === angle.fname
                            ? { ...item, fval: e.target.value }
                            : item
                        );
                        setInfosAngle(newInfosAngle);
                      }}
                      className={styles.rsRange}
                      type="number"
                      step="1"
                      value={angle.fval}
                      min="-180"
                      max="180"
                    />
                  </div>
                );
              })}
          </div>
          <div>
            <SpeakersGraph
              data={infosAngle}
              numberSpeakers={displayAngleValue(
                infosAngle,
                "FMOD_Speaker_Mode"
              )}
            />
          </div>

          {loading && <Loader />}
          {success && (
            <Success success={t("calibration_data.values_saved_success")} />
          )}

          <div className={styles.containerInputGeneral}>
            <h4>{t("calibration_data.general_correction")}</h4>
            <input
              type="number"
              step={0.1}
              value={speakersGeneral}
              onChange={(e) => setSpeakersGeneral(e.target.value)}
            />
          </div>

          {/* tonal */}
          <h4>{t("calibration_data.tonal_correction")}</h4>
          <div className={styles.tableScroll}>
            <table className={styles.calibTable}>
              <thead>
                <tr>
                  <th></th>
                  {frequencies.map((freq, i) => (
                    <th key={i}>{freq}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.keys(speakersTonal).map((key) => (
                  <tr key={key}>
                    <td className={styles.rowLabel}>{key}</td>
                    {speakersTonal[key].map((value, i) => (
                      <td key={i}>
                        <input
                          type="number"
                          step={0.1}
                          value={value}
                          onChange={(event) => handleInputChangeTonal(event, key, i)}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* vocal */}
          <h4>{t("calibration_data.vocal_correction")}</h4>
          <div className={styles.tableScroll}>
            <table className={styles.calibTable}>
              <tbody>
                {Object.keys(speakersVocal).map((key) => (
                  <tr key={key}>
                    <td className={styles.rowLabel}>{key}</td>
                    {speakersVocal[key].map((value, i) => (
                      <td key={i}>
                        <input
                          type="number"
                          step={0.1}
                          value={value}
                          onChange={(event) => handleInputChangeVocal(event, key, i)}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={styles.containerAllSerial}>
            <div className={styles.containerSerial}>
              <div className={styles.serial}>
                <h4>{t("calibration_data.mic_name")}</h4>

                <span>{microphoneName}</span>
              </div>
              <div className={styles.serial}>
                <h4>{t("calibration_data.mic_serial")}</h4>

                <span>{microphoneSerial}</span>
              </div>
            </div>
          </div>
          <div className={styles.containerBtnRegisterNewValue}>
            <PermissionGate actionKey="cabines.transducers.calibration.update">
            <Button
              onPress={() => {
                setOverlay(true);
                setModalConfirmRegisterNewValue(true);
              }}
              styles={"btnValidation"}
              text={t("calibration_data.save_new_values")}
            /></PermissionGate>
          </div>

          {modalConfirmRegisterNewValue && !modalConfirmImport && (
            <ModalConfirmRegisterNewValue
              setOverlay={setOverlay}
              setModalConfirmRegisterNewValue={setModalConfirmRegisterNewValue}
              setModalConfirmImport={setModalConfirmImport}
              isCheckedDateUpdate={isCheckedDateUpdate}
              checkHandler={checkHandler}
              registerNewValue={registerNewValueSpeakers}
            />
          )}
          <div className={styles.success}>
            {success && (
              <Success success={t("calibration_data.values_saved_success")} />
            )}
            {loading && <Loader />}
          </div>
        </div>
      </>
    </>
  );
};

export default SpeakersSettings;
